import { Table } from '@exxonmobil/react-unity';
import React from 'react';
import styled from 'styled-components';
import { EndpointData } from '../types/EndpointData';
import { ErrorBox } from '../../common/components/ErrorBox';
import { DataTableLoading } from '../../common/components/TableLoading';
import { EndpointRow } from './EndpointRow';
import { numberMillify } from '../../common/utils/numberUtil';

interface Props {
  data: EndpointData[];
  error: string;
  isLoading: boolean;
  onRefresh: () => void;
}

export const EndpointBody = ({ data, error, onRefresh, isLoading }: Props) => {
  if (isLoading) {
    return <DataTableLoading rowNumber={5} columnSpan={12} />;
  }

  if (error) {
    if (error === '401' || error === '403') {
      return <CenteredContainer>Sessions timeout, please close the page and login again.</CenteredContainer>;
    }
    return (
      <CenteredContainer>
        <ErrorBox onRefresh={onRefresh} isRefreshable />
      </CenteredContainer>
    );
  }

  if (data.length === 0) {
    return <CenteredContainer>No data available in table</CenteredContainer>;
  }

  return (
    <Table.Body style={{ display: 'relative' }}>
      {data.map((domain: EndpointData) => (
        // @ts-ignore
        <Table.Body.GroupedRow
          key={domain.id}
          // open
          cells={
            <domain.groupedColumnComponent
              name={domain.groupedColumnValue as string}
              process={domain.groupedColumnAdditionalValue as string}
              totalConsumptionVolume={numberMillify(domain.totalConsumptionVolume)}
              totalConsumers={domain.totalConsumers}
            />
          }
        >
          {domain.rows.map((row) => (
            <EndpointRow row={row} />
          ))}
          {/* @ts-ignore */}
        </Table.Body.GroupedRow>
      ))}
    </Table.Body>
  );
};

const CenteredContainer = styled.div`
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40%;
  text-align: center;
`;
